
<template>
    <div>
        <v-progress-linear indeterminate v-if="loading || agent_loading"></v-progress-linear>
        <q-drilldown-agent-data-table :loading="loading || agent_loading" :title="the_title" :the-data="the_data" :headers="headers"
                                      v-on:filters="updateFilters" :filters="filters" @reload="loadData" :agent-code="agent_code"
                                      :allow-drilldown="false" sort-by="DatePhaseComplete" :sort-desc="true" :export-fields="export_fields">
            <template #append-top>
                <p></p>
            </template>
            <template #append-bottom>
            </template>
            <template #filters>
                <q-business-time-period-select :dont-reset="false" class="mr-4" ref="periodSelect" v-model="datePeriod"
                                               label="Time Period" :allow-current="true" stateKey="stat">
                </q-business-time-period-select>
            </template>
        </q-drilldown-agent-data-table>
    </div>
</template>
<script>

import QDrilldownAgentDataTable from '@/components/datatables/Drilldowns/QDrilldownAgentDataTable.vue';
import QBusinessTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue';
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { debounce } from 'vue-debounce'
export default {
    name: "QPhaseCompletedDrilldown",
    props: [],
    data() {
        return {
            the_data: null,
            agent: null,
            loading: false,
            agent_loading: false,
            datePeriod: {},
            backup_filters: {},
            filters: {
                startDate: null,
                endDate: null,
                timePeriod: 'month',
                statType: 'TotalAgency'
            }
        }
    },
    mounted: function() {
        this.filters = {
            endDate: this.$route.query.endDate,
            startDate: this.$route.query.startDate,
            timePeriod: this.$route.query.timePeriod,
            statType: this.$route.query.statType,
            phase: this.$route.query.phase
        }

        this.datePeriod = {
            endDateFormat: this.$route.query.endDate,
            startDateFormat: this.$route.query.startDate,
            period: this.$route.query.timePeriod
        }
        this.$refs.periodSelect.selectOption(this.$route.query.endDate, this.$route.query.timePeriod)
        var g = this
        this.backup_filters = this.filters
        this.loadAgent(this.agent_code).then(function() {
            g.loadData();
        })
    },
    computed: {
        agent_code: function() {
            if (typeof this.$route.params.agent_code != 'undefined' && this.$route.params.agent_code != null) {
                return this.$route.params.agent_code;
            }
            return this.user.Agent.AgentCode;
        },
        headers: function() {
            return [{
                    text: 'Agent',
                    value: 'AgentName',
                },
                {
                    text: 'Title',
                    value: 'LeadershipLevel',
                },
                {
                    text: 'Phase Completed On',
                    value: 'DatePhaseComplete',
                },
            ]
        },
        the_title: function() {
            if (typeof this.agent == 'undefined' || this.agent == null) {
                return this.filters.phase + ' Phase Completed';
            }
            return this.agent.AgentName + ' ' +this.filters.phase + ' Phase Completed';
        },
        export_fields: function() {
            return [
                'AgentCode', 'AgentName', 'LeadershipLevel', 'DatePhaseComplete',
            ];
        }
    },
    methods: {
        updateFilters: function(f) {
            this.filters = f
            this.backup_filters = this.filters
        },
        loadData: function() {
            var g = this
            this.loading = true
            //get the data for the agent for this scorecard.
            if (this.agent == null) {
                return
            }
            if (typeof this.filters == 'undefined' || typeof this.filters.timePeriod == undefined) {
                this.filters = this.backup_filters
                return
            }
            var params = {
                ...this.filters
            }
            //if this is just an agency owner, then we override the filter and request the base shop.
            if (params.statType == "TotalAgency" && !this.agent.HasDownline) {
                params.statType = "Baseshop"
            }
            //if this is a second level drill down, then we have to force baseshop to make the numbers match the previous drill down.
            if (this.$route.params.forceBaseshop === true) {
                params.statType = "Baseshop"
            }

            g.the_data = []
            var q_name = "getDrillDown_SummitPhaseCompleted"
            QuilityAPI.cancelQRequest(q_name);
            QuilityAPI.getRequest("/api/private/scorecards/summit-phase-completed/" + this.agent_code + "/drilldown", params, q_name).then(function(json) {
                    g.the_data = json.data
                    g.loading = false;
                },
                function(error) {
                    g.loading = false;
                    console.log(error)
                    return error
                })
        },
        loadAgent: function(agentCode) {
            var g = this
            g.agent_loading = true;
            return QuilityAPI.getAgentStateless(this.agent_code).then(function(json) {
                g.$set(g, 'agent', json);
                g.agent_loading = false
            }).catch(function(err) {
                console.log(err)
                g.agent_loading = false
            })
        },
    },
    watch: {
        'filters': {
            deep: true,
            handler: function(newV) {
                this.loadData();
            }
        },
        'agent_code': function(newV) {
            this.agent = null
            var g = this
            this.loading = true
            this.the_data = []
            this.loadAgent(this.agent_code).then(function() {
                g.loadData();
            })
        },
        'datePeriod': {
            deep: true,
            handler: function(newValue) {
                var g = this
                if (typeof newValue == 'undefined') {
                    return
                }
                if (g.filters.endDate != newValue.endDateFormat || g.filters.startDate != newValue.startDateFormat || g.filters.timePeriod != newValue.period) {
                    g.$nextTick(function() {
                        g.updateFilters({
							startDate: newValue.startDateFormat,
							endDate: newValue.endDateFormat,
                            timePeriod: newValue.period,
                            statType: g.filters.statType,
                            phase: this.$route.query.phase,
                        })
                    })
                }
            }
        },
        '$route.query.phase': function() {
			if (this.$route.query.phase === undefined) {
				// No phase param, probably navigating away from the drilldown
				return;
			}
            this.filters.phase = this.$route.query.phase;
            this.loadData();
        }
    },
    components: {
        QDrilldownAgentDataTable,
        QBusinessTimePeriodSelect,
    }
}
</script>
<style scoped>
</style>
